import AccordionCustom from './AccordionCustom';

export default AccordionCustom;
